export default __webpack_public_path__ + "slices/main/assets/public/media/homepage-community@2x.37eeb785e668b442d115bcd542a944de.png";